export default __webpack_public_path__ + "static/py-test-fed3b8bdf34e7c10bbe8407e86ec37a9.svg";